<div class="font-bold pb-3 text-2xl flex flex-row">
  <ng-container *ngIf="shiftFilterDate$ | async as shiftFilterDate; else today"
    >Drivers At {{ shiftFilterDate | standardDate }}
    <sup class="text-base font-medium h-2 w-2 text-gray-600 cursor-pointer" (click)="clearDate()">&#10005;</sup>&nbsp;
  </ng-container>
  <ng-template #today>
    <div class="mr-1">Drivers</div>
  </ng-template>
</div>
<div class="card-with-shadow bg-white p-2">
  <mat-tab-group>
    <mat-tab>
      <ng-template mat-tab-label>
        On Shift
        <lohi-number-badge bgClass="bg-blue-500" [count]="(inProgressShiftDrivers$ | async).length"></lohi-number-badge>
      </ng-template>
      <div class="py-2 flex flex-col">
        <!--<div class="flex flex-row items-center">
          Filter By:
          <mat-chip-list class="ml-2">
            <mat-chip><span class="font-semibold">Needs Attention</span></mat-chip>
            <mat-chip><span class="font-semibold">On PreLoad</span></mat-chip>
          </mat-chip-list>
        </div>-->
        <div class="flex flex-row items-center">
          Sort By:
          <mat-chip-list class="ml-2">
            <mat-chip (click)="setSortHeaderOS('driverName')"
              ><span class="font-semibold">A-Z</span>
              <lohi-sort-indicator
                [activeColumn]="sortByOS === 'driverName'"
                [reversed]="sortReverseOS"
              ></lohi-sort-indicator>
            </mat-chip>
            <mat-chip (click)="setSortHeaderOS('inProgressShift.endTimestamp')"
              ><span class="font-semibold">Time Remaining</span>
              <lohi-sort-indicator
                [activeColumn]="sortByOS === 'inProgressShift.endTimestamp'"
                [reversed]="sortReverseOS"
              ></lohi-sort-indicator>
            </mat-chip>
            <mat-chip (click)="setSortHeaderOS('actionNeeded.actionNeededDescription')"
              ><div class="font-semibold flex items-center">
                <div class="text-red-500 mr-1">
                  <mat-icon>warning</mat-icon>
                </div>
                Needs Attention
              </div>
              <lohi-sort-indicator
                [activeColumn]="sortByOS === 'actionNeeded.actionNeededDescription'"
                [reversed]="sortReverseOS"
              ></lohi-sort-indicator>
            </mat-chip>
          </mat-chip-list>
        </div>
      </div>
      <div *ngIf="inProgressShiftDrivers$ | async as drivers">
        <ng-container *ngIf="drivers.length; else noDrivers">
          <a
            [routerLink]="['/', 'drivers', driver.id]"
            class="grid grid-cols-2 py-2 border-b border-gray-400 last:border-0"
            *ngFor="let driver of drivers"
          >
            <div class="flex flex-row font-semibold">
              <span [ngStyle]="{ 'font-red-500': !!driver.actionNeeded }">{{ driver.driverName }}</span>
              <mat-icon
                inline
                *ngIf="!driver.allowShiftBooking"
                class="text-red-500 ml-1"
                matTooltip="Blocked from Booking Shifts"
              >
                event_busy
              </mat-icon>
              <!--<a
                class="text-red-500 ml-1 flex flex-row"
                *ngIf="driver.inProgressShift?.unassignedCount + driver.inProgressShift?.rejectedCount as missedCount"
                >{{ missedCount }} Missed Load{{ missedCount > 1 ? 's' : '' }}
                <mat-icon class="ml-1 text-green-500" inline>chat_bubble</mat-icon>
              </a>-->
            </div>
            <div class="text-right" (click)="$event.preventDefault(); $event.stopPropagation(); startEditHOS(driver)">
              {{ driver.inProgressShift.endTimestamp | fromNow: 2:'':true }}
              Remaining
            </div>
            <div class="col-span-2">
              <ng-container *lohiRelationship="['broker', 'carrier']">
                <span
                  *ngIf="driver.userTakeRateName"
                  class="rounded-full px-1"
                  [ngClass]="{
                    'text-white':
                      driver.userTakeRateName === 'Black' ||
                      driver.userTakeRateName === 'Silver' ||
                      driver.userTakeRateName === 'Blue',
                    'bg-black': driver.userTakeRateName === 'Black',
                    'bg-yellow-500': driver.userTakeRateName === 'Gold',
                    'bg-gray-600': driver.userTakeRateName === 'Silver',
                    'bg-blue-500': driver.userTakeRateName === 'Blue'
                  }"
                >
                  {{ driver.userTakeRateName }} - {{ 1 - driver.userTakeRate | percent: '0.0-2' }}
                </span>
              </ng-container>
            </div>
            <ng-container *ngIf="driver.phoneNumber | inProgressLoadByPhoneV2 | async as order; else noLoad">
              <div>
                On Load <span class="font-semibold">{{ order.uniqueId }}</span>
              </div>
              <div class="text-gray-600 text-right">Updated {{ order.waypointTimestamp | ago }}</div>
              <div class="col-span-2" *ngIf="order.originSiteName || order.destinationSiteName">
                <span class="mr-1">{{ order.originSiteName | dashIfNothing }}</span>
                <mat-icon inline>arrow_right_alt</mat-icon>
                <span class="ml-1">{{ order.destinationSiteName | dashIfNothing }}</span>
              </div>
            </ng-container>
            <ng-template #noLoad> </ng-template>
            <div class="font-semibold">
              {{ driver.currentShiftLoadCountPartials }} / {{ driver.inProgressShift?.estimatedTurnsUpper }}
            </div>
            <div>
              <div class="flex flex-row justify-end" *lohiEarningsProgramMember>
                <span class="font-semibold text-right"
                  >Driver Score: {{ (driver.id | hseScoreFromId | async)?.Score }}</span
                >
              </div>
            </div>
            <div class="col-span-2">
              <div class="text-red-500" *ngIf="!!driver.actionNeeded">
                <span [tooltip]="driver.actionNeeded.actionNeededDescription">{{
                  driver.actionNeeded.actionNeededTitle
                }}</span>
              </div>
              <div class="text-red-500" *ngIf="driver.driverCut == null">
                <span
                  tooltip="Used to show a driver how much they can expect to earn. Percent of that load's revenue (less any fuel surcharge) the driver can expect to earn."
                  >Driver's Earnings Percentage Needs Set</span
                >
              </div>
              <ng-container *lohiFeatureFlag="'safety'">
                <ng-container *lohiEarningsProgramMember>
                  <div class="text-red-500" *ngIf="(driver.id | hseScoreFromId | async)?.ViolationsCount > 0">
                    <div>{{ (driver.id | hseScoreFromId | async)?.ViolationsCount }} Safety Violations</div>
                  </div>
                  <div class="text-red-500" *ngIf="(driver.id | hseScoreFromId | async)?.IsSuspended">
                    <div>Driver account suspended for too many safety violations.</div>
                  </div>
                </ng-container>
              </ng-container>
            </div>
          </a>
        </ng-container>
      </div>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>
        Booked
        <lohi-number-badge
          showIfZero
          bgClass="bg-black"
          [count]="(upcomingShiftDrivers$ | async).length"
        ></lohi-number-badge>
      </ng-template>
      <div class="py-2 flex flex-col">
        <!--<div class="flex flex-row items-center">
          Filter By:
          <mat-chip-list class="ml-2">
            <mat-chip><span class="font-semibold">Needs Attention</span></mat-chip>
            <mat-chip><span class="font-semibold">On PreLoad</span></mat-chip>
          </mat-chip-list>
        </div>-->
        <div class="flex flex-row items-center">
          Sort By:
          <mat-chip-list class="ml-2">
            <mat-chip (click)="setSortHeaderUS('driverName')"
              ><span class="font-semibold">A-Z</span>
              <lohi-sort-indicator
                [activeColumn]="sortByUS === 'driverName'"
                [reversed]="sortReverseUS"
              ></lohi-sort-indicator>
            </mat-chip>
            <mat-chip (click)="setSortHeaderUS('upcomingShift.startTimestamp')"
              ><span class="font-semibold">Start Time</span>
              <lohi-sort-indicator
                [activeColumn]="sortByUS === 'upcomingShift.startTimestamp'"
                [reversed]="sortReverseUS"
              ></lohi-sort-indicator>
            </mat-chip>
          </mat-chip-list>
        </div>
      </div>
      <ng-container *ngIf="(upcomingShiftDrivers$ | async).length; else noDrivers">
        <a
          [routerLink]="['/', 'drivers', driver.id]"
          *ngFor="let driver of upcomingShiftDrivers$ | async; trackBy: 'id' | trackByKey"
          class="py-2 border-gray-400 border-b last:border-0 grid grid-cols-2"
        >
          <div class="flex flex-col">
            <div class="flex flex-row">
              <span class="font-semibold">{{ driver.driverName }}</span>
              <mat-icon
                inline
                *ngIf="driver.priorityDriver"
                class="text-yellow-500 ml-1"
                matTooltip="Marked Priority by {{ driver.priorityDriver.priorityStartedBy }} at {{
                  driver.priorityDriver.priorityStartedAt | standardDate
                }}"
                >star_rate
              </mat-icon>
              <mat-icon
                inline
                *ngIf="!driver.allowShiftBooking"
                class="text-red-500 ml-1"
                matTooltip="Blocked from Booking Shifts"
              >
                event_busy
              </mat-icon>
            </div>
            <div class="text-red-500" *ngIf="driver.driverCut == null">
              <span
                tooltip="Used to show a driver how much they can expect to earn. Percent of that load's revenue (less any fuel surcharge) the driver can expect to earn."
                >Driver's Earnings Percentage Needs Set</span
              >
            </div>
            <ng-container *lohiFeatureFlag="'safety'">
              <ng-container *lohiEarningsProgramMember>
                <div class="text-red-500" *ngIf="(driver.id | hseScoreFromId | async)?.ViolationsCount > 0">
                  <div>{{ (driver.id | hseScoreFromId | async)?.ViolationsCount }} Safety Violations</div>
                </div>
                <div class="text-red-500" *ngIf="(driver.id | hseScoreFromId | async)?.IsSuspended">
                  <div>Driver account suspended for too many safety violations.</div>
                </div>
              </ng-container>
            </ng-container>
          </div>
        </a>
      </ng-container>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>
        Available
        <lohi-number-badge
          showIfZero
          bgClass="bg-green-500"
          [count]="(availableDrivers$ | async)?.length"
        ></lohi-number-badge>
      </ng-template>
      <div class="py-2 flex flex-col">
        <!--<div class="flex flex-row items-center">
          Filter By:
          <mat-chip-list class="ml-2">
            <mat-chip><span class="font-semibold">Day Shift</span></mat-chip>
            <mat-chip><span class="font-semibold">Night Shift</span></mat-chip>
          </mat-chip-list>
        </div>-->
        <div class="flex flex-row items-center">
          Sort By:
          <mat-chip-list class="ml-2">
            <mat-chip (click)="setSortHeaderA('name')"
              ><span class="font-semibold">A-Z</span>
              <lohi-sort-indicator [activeColumn]="sortByA === 'name'" [reversed]="sortReverseA"></lohi-sort-indicator>
            </mat-chip>
          </mat-chip-list>
        </div>
      </div>
      <ng-container *ngIf="(availableDrivers$ | async)?.length; else noDrivers">
        <div
          *ngFor="let driver of availableDrivers$ | async; trackBy: 'id' | trackByKey"
          class="py-2 border-gray-400 border-b last:border-0 flex flex-row justify-between"
        >
          <a [routerLink]="['/', 'drivers', driver.userId]">
            <span class="font-semibold">{{ driver.name }}</span>
            <ng-container *ngIf="driver.phone | userFromPhone | async as driverData">
              <mat-icon
                inline
                *ngIf="!driverData.allowShiftBooking"
                class="text-red-500 ml-1"
                matTooltip="Blocked from Booking Shifts"
              >
                event_busy
              </mat-icon>
              <div class="text-red-500 text-right" *ngIf="driverData.driverCut == null">
                <span
                  tooltip="Used to show a driver how much they can expect to earn. Percent of that load's revenue (less any fuel surcharge) the driver can expect to earn."
                  >Driver's Earnings Percentage Needs Set</span
                >
              </div>
              <ng-container *lohiFeatureFlag="'safety'">
                <ng-container *lohiEarningsProgramMember>
                  <div class="text-red-500" *ngIf="(driver.id | hseScoreFromId | async)?.ViolationsCount > 0">
                    <div>{{ (driver.id | hseScoreFromId | async)?.ViolationsCount }} Safety Violations</div>
                  </div>
                  <div class="text-red-500" *ngIf="(driver.id | hseScoreFromId | async)?.IsSuspended">
                    <div>Driver account suspended for too many safety violations.</div>
                  </div>
                </ng-container>
              </ng-container>
            </ng-container>
          </a>
          <a href="tel:{{ driver.phone }}" class="text-gray-600"
            ><mat-icon class="ml-1 text-green-500" inline>chat_bubble</mat-icon> {{ driver.phone | phone }}</a
          >
        </div>
      </ng-container>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>
        Unavailable
        <lohi-number-badge
          showIfZero
          bgClass="bg-black"
          [count]="(hosResetDrivers$ | async).length"
        ></lohi-number-badge>
      </ng-template>
      <div class="py-2 flex flex-col">
        <!--<div class="flex flex-row items-center">
          Filter By:
          <mat-chip-list class="ml-2">
            <mat-chip><span class="font-semibold">Resetting</span></mat-chip>
          </mat-chip-list>
        </div>-->
        <div class="flex flex-row items-center">
          Sort By:
          <mat-chip-list class="ml-2">
            <mat-chip (click)="setSortHeaderUA('driverName')"
              ><span class="font-semibold">A-Z</span>
              <lohi-sort-indicator
                [activeColumn]="sortByUA === 'driverName'"
                [reversed]="sortReverseUA"
              ></lohi-sort-indicator>
            </mat-chip>
            <mat-chip (click)="setSortHeaderUA('previousShift.endTimestamp')"
              ><span class="font-semibold">Last Shift</span>
              <lohi-sort-indicator
                [activeColumn]="sortByUA === 'previousShift.endTimestamp'"
                [reversed]="sortReverseUA"
              ></lohi-sort-indicator>
            </mat-chip>
          </mat-chip-list>
        </div>
      </div>
      <ng-container *ngIf="(hosResetDrivers$ | async).length; else noDrivers">
        <a
          [routerLink]="['/', 'drivers', driver.id]"
          *ngFor="let driver of hosResetDrivers$ | async; trackBy: 'id' | trackByKey"
          class="py-2 border-gray-400 border-b last:border-0 flex flex-row justify-between"
        >
          <div class="flex flex-col">
            <div class="flex flex-row">
              <span class="font-semibold">{{ driver.driverName }}</span>
              <mat-icon
                inline
                *ngIf="driver.priorityDriver"
                class="text-yellow-500 ml-1"
                matTooltip="Marked Priority by {{ driver.priorityDriver.priorityStartedBy }} at {{
                  driver.priorityDriver.priorityStartedAt | standardDate
                }}"
                >star_rate
              </mat-icon>
              <mat-icon
                inline
                *ngIf="!driver.allowShiftBooking"
                class="text-red-500 ml-1"
                matTooltip="Blocked from Booking Shifts"
              >
                event_busy
              </mat-icon>
            </div>
            <span>{{ driver.phoneNumber | phone }}</span>
            <div class="text-red-500 text-right" *ngIf="driver.driverCut == null">
              <span
                tooltip="Used to show a driver how much they can expect to earn. Percent of that load's revenue (less any fuel surcharge) the driver can expect to earn."
                >Driver's Earnings Percentage Needs Set</span
              >
            </div>
            <ng-container *lohiFeatureFlag="'safety'">
              <ng-container *lohiEarningsProgramMember>
                <div class="text-red-500" *ngIf="(driver.id | hseScoreFromId | async)?.ViolationsCount > 0">
                  <div>{{ (driver.id | hseScoreFromId | async)?.ViolationsCount }} Safety Violations</div>
                </div>
                <div class="text-red-500" *ngIf="(driver.id | hseScoreFromId | async)?.IsSuspended">
                  <div>Driver account suspended for too many safety violations.</div>
                </div>
              </ng-container>
            </ng-container>
          </div>
          <div class="flex flex-col">
            <span class="text-gray-600 text-right" *ngIf="driver.previousShift"
              >Last Shift {{ driver.previousShift?.endTimestamp | ago }}</span
            >
          </div>
        </a>
      </ng-container>
    </mat-tab>
    <!--<div *ngIf="needsAttentionShifts$ | async as needsAttentionDrivers">
      <div class="text-gray-600 font-bold">
        Late or Needs Attention
        <span [class.text-red-500]="needsAttentionDrivers.length + (lateDriverLoads$ | async)?.length > 0">
          {{ needsAttentionDrivers.length + (lateDriverLoads$ | async)?.length }}
        </span>
      </div>
      <a
        class="p-2 border-b border-gray-400 last:border-0 flex"
        *ngFor="let driver of lateDriverLoads$ | async; trackBy: 'id' | trackByKey"
        [routerLink]="['/', 'drivers', driver.driverId]"
      >
        <div class="flex-1">
          <div>
            <div class="text-gray-900 font-semibold">
              {{ driver.name }}
              <mat-icon
                *ngIf="driver.priorityDriver"
                class="text-yellow-500"
                matTooltip="Marked Priority by {{ driver.priorityDriver.priorityStartedBy }} at {{
                  driver.priorityDriver.priorityStartedAt | standardDate
                }}"
              >star_rate
              </mat-icon
              >
              <mat-icon
                *ngIf="!driver.allowShiftBooking"
                class="text-red-500"
                matTooltip="Blocked from Booking Shifts"
              >
                event_busy
              </mat-icon>
            </div>
            <div class="text-red-500">{{ driver.lateOrder }}h Late! Call driver</div>
            <div class="text-red-500" *ngIf="driver.delayedReason">{{ driver.delayedReason }}</div>
          </div>
        </div>
        <div>
          <div class="text-gray-600">{{ driver.waypointTimestamp | ago }}</div>
        </div>
      </a>
      <a
        class="p-2 border-b border-gray-400 last:border-0 flex"
        [routerLink]="['/', 'drivers', driver.id]"
        *ngFor="let driver of needsAttentionDrivers; trackBy: 'id' | trackByKey"
      >
        <div class="flex-1">
          <div class="text-gray-900 font-semibold">
            {{ driver.driverName }}
            <mat-icon
              *ngIf="driver.priorityDriver"
              class="text-yellow-500"
              matTooltip="Marked Priority by {{ driver.priorityDriver.priorityStartedBy }} at {{
                driver.priorityDriver.priorityStartedAt | standardDate
              }}"
            >star_rate
            </mat-icon
            >
            <mat-icon *ngIf="!driver.allowShiftBooking" class="text-red-500" matTooltip="Blocked from Booking Shifts">
              event_busy
            </mat-icon>
          </div>
          <div class="text-gray-700">
            <ng-container *ngIf="driver.phoneNumber | inProgressLoadByPhoneV2 | async as order"
            >On Load <span class="font-semibold">{{ order.uniqueId }}</span> •
            </ng-container
            >
            {{ $any(driver).currentShiftLoadCountPartials }} /
            {{
            $any(driver).currentShiftLoadCountPartials | max: driver.inProgressShift?.estimatedTurnsUpper | number
            }}
          </div>
          <div
            *ngIf="driver.inProgressShift?.unassignedCount + driver.inProgressShift?.rejectedCount as missedCount"
            class="text-red-500"
          >
            {{ missedCount }} load
            <ng-container *ngIf="missedCount !== 1">s</ng-container>
            missed
          </div>
          <div class="text-red-500" *ngIf="driver.delayedReason">{{ driver.delayedReason }}</div>
          <div class="text-red-500" *ngIf="driver.driverCut == null">
            <span
              tooltip="Used to show a driver how much they can expect to earn. Percent of that load's revenue (less any fuel surcharge) the driver can expect to earn."
            >Driver's Earnings Percentage Needs Set</span
            >
          </div>
        </div>
        <div>
          <ng-container *ngIf="driver.phoneNumber | inProgressLoadByPhoneV2 | async as order">
            <div class="text-gray-900">Updated {{ order.waypointTimestamp | ago: 1:'ago':true }}</div>
          </ng-container>
          <div class="text-gray-700">{{ driver.inProgressShift.endTimestamp | fromNow: 1:'':true }} Remaining</div>
        </div>
      </a>
    </div>
    <div *ngIf="inProgressLoadsOffShift$ | async as onLoaders">
      <div class="text-gray-600 font-bold">
        On PreLoad
        <span [class.text-blue-500]="onLoaders.length > 0">
          {{ onLoaders.length }}
        </span>
      </div>
      <a
        class="p-2 border-b border-gray-400 last:border-0 flex"
        *ngFor="let driver of onLoaders; trackBy: 'id' | trackByKey"
        [routerLink]="['/', 'drivers', driver.driverId]"
      >
        <div class="flex-1">
          <div>
            <div class="text-gray-900 font-semibold">{{ driver.name }}</div>
            <div class="text-gray-700">On PreLoad • {{ driver.uniqueId }}</div>
          </div>
        </div>
        <div>
          <div class="text-gray-700">{{ driver.waypointTimestamp | ago }}</div>
        </div>
      </a>
    </div>
    <div *ngIf="onShiftOkDrivers$ | async as onShiftOk">
      <div class="text-gray-600 font-bold">
        On Shift
        <span [class.text-blue-500]="onShiftOk.length + (inProgressLoadsOnShift$ | async)?.length > 0">
          {{ onShiftOk.length + (inProgressLoadsOnShift$ | async)?.length }}
        </span>
      </div>
      <a
        class="p-2 border-b border-gray-400 last:border-0 flex"
        *ngFor="let driver of inProgressLoadsOnShift$ | async; trackBy: 'id' | trackByKey"
        [routerLink]="['/', 'drivers', driver.driverId]"
      >
        <div class="flex-1">
          <div>
            <div class="text-gray-900 font-semibold">{{ driver.name }}</div>
            <div class="text-gray-700">On Last Load • {{ driver.uniqueId }}</div>
          </div>
        </div>
        <div>
          <div class="text-gray-700">{{ driver.waypointTimestamp | ago }}</div>
        </div>
      </a>
      <a
        class="p-2 border-b border-gray-400 last:border-0 flex"
        [routerLink]="['/', 'drivers', driver.id]"
        *ngFor="let driver of onShiftOk; trackBy: 'id' | trackByKey"
      >
        <div class="flex-1">
          <div class="text-gray-900 font-semibold">
            {{ driver.driverName }}
            <mat-icon
              *ngIf="driver.priorityDriver"
              class="text-yellow-500"
              matTooltip="Marked Priority by {{ driver.priorityDriver.priorityStartedBy }} at {{
                driver.priorityDriver.priorityStartedAt | standardDate
              }}"
            >star_rate
            </mat-icon
            >
            <mat-icon *ngIf="!driver.allowShiftBooking" class="text-red-500" matTooltip="Blocked from Booking Shifts">
              event_busy
            </mat-icon>
          </div>
          <div class="text-gray-700">
            <ng-container *ngIf="driver.phoneNumber | inProgressLoadByPhoneV2 | async as order"
            >On Load <span class="font-semibold">{{ order.uniqueId }}</span> •
            </ng-container
            >
            {{ driver.currentShiftLoadCount }} /
            {{ driver.currentShiftLoadCount | max: driver.inProgressShift?.estimatedTurnsUpper | number }}
          </div>
          <div
            *ngIf="driver.inProgressShift?.unassignedCount + driver.inProgressShift?.rejectedCount as missedCount"
            class="text-red-500"
          >
            {{ missedCount }} load
            <ng-container *ngIf="missedCount !== 1">s</ng-container>
            missed
          </div>
          <div class="text-red-500" *ngIf="driver.driverCut == null">
            <span
              tooltip="Used to show a driver how much they can expect to earn. Percent of that load's revenue (less any fuel surcharge) the driver can expect to earn."
            >Driver's Earnings Percentage Needs Set</span
            >
          </div>
        </div>
        <div class="text-right">
          <ng-container *ngIf="driver.phoneNumber | inProgressLoadByPhoneV2 | async as order">
            <div class="text-gray-900">Updated {{ order.waypointTimestamp | ago: 1:'ago':true }}</div>
          </ng-container>
          <div class="text-gray-700">{{ driver.inProgressShift.endTimestamp | fromNow: 1:'':true }} Remaining</div>
        </div>
      </a>
    </div>
  </mat-tab>
  <mat-tab>
    <ng-template mat-tab-label>
      Booked Shifts
      {{ (upcomingShiftDrivers$ | async).length || 0 }}
    </ng-template>
    <div class="h-2"></div>
    <div *ngIf="upcomingShiftDrivers$ | async as scheduledDrivers">
      <div class="text-gray-600 font-bold">
        Scheduled
        <span [class.text-blue-500]="scheduledDrivers.length > 0">
          {{ scheduledDrivers.length }}
        </span>
      </div>
      <a
        class="p-2 border-b border-gray-400 last:border-0 flex"
        *ngFor="let driver of scheduledDrivers; trackBy: 'id' | trackByKey"
        [routerLink]="['/', 'drivers', driver.id]"
      >
        <div class="flex-1">
          <div class="text-gray-900 font-semibold">
            {{ driver.driverName }}
            <mat-icon
              *ngIf="driver.priorityDriver"
              class="text-yellow-500"
              matTooltip="Marked Priority by {{ driver.priorityDriver.priorityStartedBy }} at {{
                driver.priorityDriver.priorityStartedAt | standardDate
              }}"
            >star_rate
            </mat-icon
            >
            <mat-icon *ngIf="!driver.allowShiftBooking" class="text-red-500" matTooltip="Blocked from Booking Shifts">
              event_busy
            </mat-icon>
          </div>
          <div class="text-gray-700">Starts at {{ driver.upcomingShift?.startTimestamp | standardDate }}</div>
          <div class="text-red-500" *ngIf="driver.driverCut == null">
            <span
              tooltip="Used to show a driver how much they can expect to earn. Percent of that load's revenue (less any fuel surcharge) the driver can expect to earn."
            >Driver's Earnings Percentage Needs Set</span
            >
          </div>
        </div>
      </a>
    </div>
  </mat-tab>
  <mat-tab>
    <ng-template mat-tab-label>
      Not On Shift
      {{ (availableDrivers$ | async)?.length || 0 }}
    </ng-template>
    <div class="h-2"></div>
    <div *ngFor="let region of availableDriversByRegion$ | async; trackBy: 'id' | trackByKey">
      <div class="text-gray-700">Available in {{ region.name }} ({{ region.drivers.length }})</div>
      <a
        class="p-2 border-b border-gray-400 last:border-0 flex"
        *ngFor="let driver of region.drivers; trackBy: 'id' | trackByKey"
        [routerLink]="['/', 'drivers', driver.userId]"
      >
        <div class="flex-1">
          <div>
            <span class="text-gray-900 font-semibold">{{ driver.name }}</span> {{ driver.phone | phone }}
          </div>
        </div>
      </a>
    </div>
    <div>
      <div class="text-gray-700">Resetting HOS</div>
      <a
        class="p-2 border-b border-gray-400 last:border-0 flex"
        *ngFor="let driver of hosResetDrivers$ | async; trackBy: 'id' | trackByKey"
        [routerLink]="['/', 'drivers', driver.id]"
      >
        <div class="flex-1">
          <div>
            <span class="text-gray-900 font-semibold"
            >{{ driver.driverName }}
              <mat-icon
                *ngIf="driver.priorityDriver"
                class="text-yellow-500"
                matTooltip="Marked Priority by {{ driver.priorityDriver.priorityStartedBy }} at {{
                  driver.priorityDriver.priorityStartedAt | standardDate
                }}"
              >star_rate</mat-icon
              ></span
            >
            <mat-icon *ngIf="!driver.allowShiftBooking" class="text-red-500" matTooltip="Blocked from Booking Shifts">
              event_busy
            </mat-icon>
            {{ driver.phoneNumber | phone }}
          </div>
        </div>
      </a>
    </div>
  </mat-tab>-->
  </mat-tab-group>
</div>

<ng-template #noDrivers>
  <div class="py-2 text-center">No Drivers</div>
</ng-template>

<ng-template #updateHOS>
  <div mat-dialog-title>
    <div class="flex justify-between">
      <div>Update HOS</div>
      <div>
        <mat-icon class="cursor-pointer" mat-dialog-close>close</mat-icon>
      </div>
    </div>
  </div>
  <div mat-dialog-content>
    <div>Update HOS for {{ updateHOSFormGroup?.get('driverName')?.value }}</div>
    <mat-form-field class="w-full">
      <mat-label>Hours Left</mat-label>
      <mat-select [formControl]="updateHOSFormGroup?.get('hoursLeft')">
        <mat-option [value]="1">1 Hour</mat-option>
        <mat-option [value]="2">2 Hours</mat-option>
        <mat-option [value]="3">3 Hours</mat-option>
        <mat-option [value]="4">4 Hours</mat-option>
        <mat-option [value]="5">5 Hours</mat-option>
        <mat-option [value]="6">6 Hours</mat-option>
        <mat-option [value]="7">7 Hours</mat-option>
        <mat-option [value]="8">8 Hours</mat-option>
        <mat-option [value]="9">9 Hours</mat-option>
        <mat-option [value]="10">10 Hours</mat-option>
        <mat-option [value]="11">11 Hours</mat-option>
        <mat-option [value]="12">12 Hours</mat-option>
        <mat-option [value]="13">13 Hours</mat-option>
        <mat-option [value]="14">14 Hours</mat-option>
        <mat-option [value]="15">15 Hours</mat-option>
        <mat-option [value]="16">16 Hours</mat-option>
        <mat-option [value]="17">17 Hours</mat-option>
        <mat-option [value]="18">18 Hours</mat-option>
        <mat-option [value]="19">19 Hours</mat-option>
        <mat-option [value]="20">20 Hours</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div mat-dialog-actions class="fles justify-between">
    <button type="button" mat-flat-button matDialogClose>Close</button>
    <button type="button" color="primary" mat-raised-button matDialogClose (click)="doEditHOS()">Update</button>
  </div>
</ng-template>
